document.addEventListener('DOMContentLoaded', () => {
  const root = (document.body.dataset.shopRoot || '/').replace(/\/?$/, '/');
  const cartDrawer = document.getElementById('CartDrawer');
  const cartItems = document.getElementById('drawer-items-container');
  const cartError = document.querySelector('[data-cart-error]');
  const stickyBar = document.getElementById('StickyMobileBar');
  const offerForm = document.querySelector('[data-wellness-offer-form]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let cartData = null;
  let cartBusy = false;
  let welcomeCode = '';
  let welcomeFailed = false;
  try { if (sessionStorage.getItem('aube-welcome-claimed-v2') === '1') welcomeCode = sessionStorage.getItem('aube-wellness-coupon') || ''; } catch (_) {}
  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = cents => {
    const format = document.body.dataset.moneyFormat || '{{amount}}';
    return format.replace(/\{\{\s*(amount(?:_no_decimals)?(?:_with_(?:comma|period|apostrophe)_separator)?)\s*\}\}/g, (_, token) => {
      const digits = token.includes('no_decimals') ? 0 : 2;
      const locale = token.includes('comma_separator') ? 'de-DE' : token.includes('apostrophe') ? 'de-CH' : 'en-US';
      return new Intl.NumberFormat(locale, { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Number(cents || 0) / 100);
    }).replace(/<[^>]*>/g, '');
  };
  const scrollToOffers = () => {
    const target = document.getElementById('wellness-offers');
    if (target) target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
    return !!target;
  };
  const showDialog = dialog => {
    if (!dialog || dialog.open) return;
    dialog.showModal();
    document.body.classList.add('aube-dialog-open');
  };
  const closeDialog = dialog => dialog?.close();
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('aube-dialog-open');
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
    });
  });
  const requestCart = async (path, body) => {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {}),
      signal: AbortSignal.timeout(15000)
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'We could not update your cart. Please try again.');
    return result;
  };
  const showError = message => {
    if (!cartError) return;
    cartError.textContent = message;
    cartError.closest('[data-cart-error-container]').hidden = !message;
  };
  const syncWelcome = () => {
    const entry = cartData?.discount_codes?.find(item => item.code?.toUpperCase() === welcomeCode.toUpperCase());
    document.querySelectorAll('[data-welcome-status]').forEach(status => {
      status.hidden = !welcomeCode;
      if (status.closest('#CartDrawer')) {
        status.textContent = welcomeFailed ? `${welcomeCode} saved · enter it at checkout.` : entry?.applicable === true ? `${welcomeCode} applied · savings included below.` : entry?.applicable === false ? `${welcomeCode} saved · eligibility checked at checkout.` : `${welcomeCode} saved for eligible orders.`;
        return;
      }
      status.textContent = welcomeFailed ? `${welcomeCode} is saved. Enter it at checkout if it is not shown.` : entry?.applicable === false ? `${welcomeCode} is saved. Shopify applies the best eligible offer; discounts may not combine.` : `${welcomeCode} is saved. Eligible savings appear in your cart and at checkout.`;
    });
  };
  const renderCart = data => {
    cartData = data;
    const bottlesPerItem = item => Number(item.properties?.['Bottles per pack']) || (item.sku === 'AUBE-SUB-PACK-3' ? 3 : item.sku === 'AUBE-SUB-PACK-5' ? 5 : 1);
    const bottleCount = data.items.reduce((total, item) => total + item.quantity * bottlesPerItem(item), 0);
    document.querySelector('[data-cart-announcement]').textContent = `${bottleCount} ${bottleCount === 1 ? 'bottle' : 'bottles'} in your cart. Subtotal ${money(data.total_price)}.`;
    document.querySelectorAll('.cart-count-badge').forEach(badge => { badge.textContent = bottleCount; });
    document.getElementById('drawer-subtotal').textContent = money(data.total_price);
    document.querySelector('[data-cart-footer]').hidden = !data.item_count;
    document.querySelector('[data-cart-tax]').textContent = data.taxes_included ? 'Taxes included.' : 'Taxes calculated at checkout.';
    const savings = data.original_total_price - data.total_price;
    const discounts = document.querySelector('[data-cart-discounts]');
    discounts.textContent = savings > 0 ? `You save ${money(savings)} on this order` : '';
    if (!data.item_count) {
      cartItems.innerHTML = `<div class="cart-empty-state"><strong>Your next ritual starts here</strong><p>Explore our single bottle and bundle offers.</p><a href="${root}#wellness-offers" class="wellness-button" data-cart-shop>Choose your pack →</a></div>`;
    } else {
      cartItems.innerHTML = data.items.map((item, index) => {
        const plan = item.selling_plan_allocation?.selling_plan;
        const labels = (item.line_level_discount_allocations || []).map(d => d.discount_application?.title).filter(Boolean);
        const discounted = item.original_line_price > item.final_line_price;
        const included = !plan && item.final_line_price === 0 && labels.length > 0;
        const itemImage = item.handle === cartDrawer.dataset.productHandle && cartDrawer.dataset.productImage ? cartDrawer.dataset.productImage : item.image;
        const title = item.product_title.replace(/\s*[·|]\s*60\s*ml$/i, '');
        return `<article class="cart-line"><div class="cart-line__image">${itemImage ? `<img src="${escapeHTML(itemImage)}${itemImage.includes('?') ? '&' : '?'}width=180" alt="${escapeHTML(item.product_title)}" width="82" height="100" loading="lazy">` : '<span>aübe</span>'}</div><div class="cart-line__details"><div class="cart-line__top"><h4>${escapeHTML(title)}</h4><div class="aube-cart-price">${discounted ? `<s>${money(item.original_line_price)}</s>` : ''}<strong>${money(item.final_line_price)}</strong></div></div><p class="aube-cart-plan">${included ? 'Included with your bundle' : plan ? `Subscription · ${bottlesPerItem(item)} ${bottlesPerItem(item) === 1 ? 'bottle' : 'bottles'} per delivery · every 8 weeks` : '60 ml · One-time purchase'}</p>${labels.map(title => `<p class="aube-cart-tag">${escapeHTML(title)}</p>`).join('')}<div class="cart-line__bottom"><div class="aube-cart-quantity"><button type="button" data-cart-change="${index}" data-cart-action="decrease" data-quantity="${Math.max(0,item.quantity-1)}" aria-label="Decrease quantity of ${escapeHTML(item.product_title)}"><svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false"><path d="M4 10h12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button><span aria-label="Quantity">${item.quantity}</span><button type="button" data-cart-change="${index}" data-cart-action="increase" data-quantity="${item.quantity+1}" aria-label="Increase quantity of ${escapeHTML(item.product_title)}"><svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false"><path d="M4 10h12M10 4v12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button></div><button type="button" class="aube-cart-remove" data-cart-change="${index}" data-cart-action="remove" data-quantity="0">Remove</button></div></div></article>`;
      }).join('');
    }
    const upgrade = document.querySelector('[data-cart-upgrade]');
    const progression = document.querySelector('[data-cart-offer-progress]');
    const variantId = offerForm?.querySelector('[value="single"]')?.dataset.variantId || progression?.dataset.variantId;
    const eligible = data.items.filter(item => String(item.variant_id) === variantId && !item.selling_plan_allocation);
    const quantity = eligible.reduce((total, item) => total + item.quantity, 0);
    const singlePrice = Number(offerForm?.querySelector('[value="single"]')?.dataset.priceCents || progression?.dataset.unitPrice || 0);
    if (progression) {
      progression.hidden = quantity === 0;
      progression.querySelector('[data-bundle-count]').textContent = `${quantity} ${quantity === 1 ? 'bottle' : 'bottles'}`;
      progression.querySelector('[data-bundle-progress-fill]').style.width = `${Math.min(100, Math.max(0, (quantity - 1) / 4 * 100))}%`;
      const currentLevel = quantity >= 5 ? 5 : quantity >= 3 ? 3 : 1;
      progression.querySelectorAll('[data-bundle-level]').forEach(step => {
        const level = Number(step.dataset.bundleLevel);
        step.classList.toggle('is-reached', quantity >= level);
        step.classList.toggle('is-current', level === currentLevel);
        if (level === currentLevel) step.setAttribute('aria-current', 'step'); else step.removeAttribute('aria-current');
      });
      const next = quantity < 3 ? 3 : 5;
      progression.querySelector('[data-bundle-progress-copy]').textContent = quantity >= 5 ? 'Top bundle level reached. See your applied savings below.' : `Add ${next - quantity} ${next - quantity === 1 ? 'bottle' : 'bottles'} to reach the ${next}-bottle offer.`;
    }
    upgrade.hidden = ![1,3].includes(quantity) || !singlePrice;
    if (!upgrade.hidden) {
      const target = quantity === 1 ? 3 : 5;
      const total = singlePrice * (target === 3 ? 2 : 3);
      upgrade.innerHTML = `<span class="wellness-eyebrow">MAKE MORE OF YOUR ORDER</span><strong>${target === 3 ? 'Buy 2, get 1 free' : 'Buy 3, get 2 free'}</strong><p>${target} bottles for ${money(total)} before other eligible discounts.</p><button type="button" data-cart-upgrade-add="${target-quantity}" data-variant="${variantId}">Upgrade to ${target} bottles →</button>`;
    }
    syncWelcome();
  };
  const loadCart = async () => { const data = await requestCart('cart.js'); renderCart(data); return data; };
  const applyWelcome = async () => {
    if (!welcomeCode) return;
    try {
      if (!cartData) await loadCart();
      const codes = [...new Set([...(cartData.discount_codes || []).map(item => item.code), welcomeCode])];
      renderCart(await requestCart('cart/update.js', { discount: codes.join(',') }));
      welcomeFailed = false;
    } catch (_) { welcomeFailed = true; }
    syncWelcome();
  };
  const busyCart = busy => {
    cartBusy = busy;
    cartDrawer?.setAttribute('aria-busy', String(busy));
    cartDrawer?.querySelectorAll('[data-cart-change],[data-cart-upgrade-add]').forEach(button => { button.disabled = busy; });
    document.getElementById('drawer-checkout-btn')?.setAttribute('aria-disabled', String(busy));
  };
  cartDrawer?.addEventListener('click', async event => {
    const shop = event.target.closest('[data-cart-shop]');
    if (shop) { closeDialog(cartDrawer); if (scrollToOffers()) event.preventDefault(); }
    const retry = event.target.closest('[data-cart-retry]');
    if (retry && !cartBusy) {
      busyCart(true); showError('');
      try { await loadCart(); } catch (error) { showError(error.message); }
      finally { busyCart(false); }
      return;
    }
    const change = event.target.closest('[data-cart-change]');
    const upgrade = event.target.closest('[data-cart-upgrade-add]');
    if ((!change && !upgrade) || cartBusy) return;
    const focusIndex = change?.dataset.cartChange;
    const focusQuantity = change?.dataset.quantity;
    const focusAction = change?.dataset.cartAction;
    const removesLine = focusQuantity === '0';
    busyCart(true); showError('');
    try {
      if (change) {
        const item = cartData.items[Number(change.dataset.cartChange)];
        renderCart(await requestCart('cart/change.js', { id: item.key, quantity: Number(change.dataset.quantity) }));
      } else {
        await requestCart('cart/add.js', { id: Number(upgrade.dataset.variant), quantity: Number(upgrade.dataset.cartUpgradeAdd) });
        await loadCart();
      }
      if (welcomeCode) await applyWelcome();
    } catch (error) { showError(error.message); }
    finally {
      busyCart(false);
      if (change) {
        const controls = [...cartDrawer.querySelectorAll('[data-cart-change]')];
        const nextFocus = removesLine ? controls.find(control => control.dataset.cartChange === focusIndex) : controls.find(control => control.dataset.cartChange === focusIndex && control.dataset.cartAction === focusAction);
        (nextFocus || controls[0] || cartDrawer.querySelector('[data-close-cart]')).focus({ preventScroll: true });
      }
    }
  });
  document.querySelectorAll('[data-open-cart]').forEach(button => button.addEventListener('click', async event => {
    event.preventDefault(); showDialog(cartDrawer); showError('');
    if (cartBusy) return;
    const loading = cartDrawer.querySelector('[data-cart-loading]');
    loading.hidden = false; busyCart(true);
    try { await loadCart(); } catch (error) { showError(error.message); }
    finally { loading.hidden = true; busyCart(false); }
  }));
  document.querySelectorAll('[data-close-cart]').forEach(button => button.addEventListener('click', () => closeDialog(cartDrawer)));
  document.getElementById('drawer-checkout-btn')?.addEventListener('click', async event => {
    if (cartBusy) { event.preventDefault(); return; }
    if (!welcomeCode) return;
    event.preventDefault(); busyCart(true);
    await applyWelcome();
    window.location.assign(welcomeFailed ? `${root}discount/${encodeURIComponent(welcomeCode)}?redirect=${encodeURIComponent(root+'checkout')}` : root+'checkout');
  });
  const cartPage = document.getElementById('cart-form');
  if (cartPage) cartPage.addEventListener('submit', async event => {
    if (event.submitter?.name !== 'checkout' || !welcomeCode) return;
    event.preventDefault(); event.submitter.disabled = true;
    await applyWelcome();
    window.location.assign(welcomeFailed ? `${root}discount/${encodeURIComponent(welcomeCode)}?redirect=${encodeURIComponent(root+'checkout')}` : root+'checkout');
  });
  const initializeWelcome = async () => {
    await loadCart();
    const offerCode = document.querySelector('[data-scratch-section]')?.dataset.couponCode;
    if (!welcomeCode && offerCode && cartData.discount_codes?.some(item => item.code?.toUpperCase() === offerCode.toUpperCase())) {
      const otherCodes = cartData.discount_codes.filter(item => item.code?.toUpperCase() !== offerCode.toUpperCase()).map(item => item.code);
      renderCart(await requestCart('cart/update.js', { discount: otherCodes.join(',') }));
    }
    if (welcomeCode) await applyWelcome();
  };
  initializeWelcome().catch(() => {});
  syncWelcome();

  document.querySelectorAll('[data-wellness-offer-form]').forEach(form => {
    const bundles = [...form.querySelectorAll('[data-bundle-input]')];
    const choices = [...form.querySelectorAll('[data-purchase-type]')];
    const button = form.querySelector('[data-bundle-submit]');
    const error = form.querySelector('[data-wellness-error]');
    let adding = false;
    const update = () => {
      const pack = bundles.find(input => input.checked);
      if (!pack) return;
      const quantity = Number(pack.dataset.quantity);
      choices.filter(input => input.hasAttribute('data-plan-id')).forEach(input => {
        input.disabled = !pack.dataset.subscriptionVariantId || !pack.dataset.subscriptionPlanId || !pack.dataset.subscriptionPriceCents;
        input.dataset.planId = pack.dataset.subscriptionPlanId || '';
        input.dataset.planPrice = pack.dataset.subscriptionPriceCents || ''; 
        if (input.disabled && input.checked) choices.find(choice => choice.value === 'once').checked = true;
        const card = input.closest('.wellness-subscription-card');
        card.classList.toggle('is-disabled', input.disabled);
        card.querySelector('[data-subscription-price]').textContent = input.disabled ? 'Currently unavailable for this pack' : `${money(input.dataset.planPrice)} every 8 weeks`;
        card.querySelector('[data-subscription-quantity]').textContent = `${quantity} ${quantity === 1 ? 'bottle' : 'bottles'} delivered every 8 weeks`;
        card.setAttribute('aria-disabled', String(input.disabled));
      });
      const plan = choices.find(input => input.checked && input.dataset.planId);
      const cents = plan ? Number(plan.dataset.planPrice) : Number(pack.dataset.priceCents);
      bundles.forEach(input => input.closest('.wellness-pack-card').classList.toggle('is-selected', input.checked));
      choices.forEach(input => input.closest('.wellness-subscription-card').classList.toggle('is-selected', input.checked));
      form.querySelector('[data-selected-variant]').value = plan ? pack.dataset.subscriptionVariantId : pack.dataset.variantId;
      form.querySelector('[data-once-price]').textContent = money(pack.dataset.priceCents);
      const note = form.querySelector('[data-selected-promo]');
      note.hidden = !pack.dataset.promoCopy;
      note.textContent = pack.dataset.promoCopy ? `${pack.dataset.promoCopy} · ${quantity} bottles included` : '';
      form.querySelector('[data-subscription-help]').hidden = !plan;
      form.querySelector('[data-plan-availability]').hidden = !choices.some(input => input.hasAttribute('data-plan-id') && input.disabled);
      form.querySelector('[data-order-summary]').textContent = `${quantity} ${quantity === 1 ? 'bottle' : 'bottles'} · ${plan ? 'subscription' : 'one-time purchase'}`;
      form.querySelector('[data-order-detail]').textContent = plan ? 'Renews every 8 weeks · pause, skip or cancel' : quantity > 1 ? `${pack.dataset.includedQuantity} paid + ${quantity - Number(pack.dataset.includedQuantity)} free · 60 ml each` : '60 ml · no recurring charge';
      form.querySelector('[data-order-total]').textContent = money(cents);
      button.setAttribute('aria-busy', String(adding));
      const unavailable = form.dataset.available === 'false' || !pack.dataset.variantId;
      button.disabled = adding || unavailable;
      button.textContent = adding ? 'Adding to cart…' : unavailable ? 'Currently unavailable' : `${plan ? 'Subscribe' : quantity > 1 ? `Add ${quantity} bottles to cart` : 'Add to cart'} · ${money(cents)} →`;
      if (stickyBar) {
        stickyBar.querySelector('[data-sticky-price]').textContent = money(cents);
        const stickyCta = stickyBar.querySelector('[data-sticky-cta]');
        stickyCta.dataset.purchaseLabel = plan ? 'Subscribe' : 'Add to cart';
        if (stickyCta.dataset.canPurchase === 'true') stickyCta.textContent = stickyCta.dataset.purchaseLabel;
        stickyBar.querySelector('[data-sticky-pack]').textContent = plan ? `${quantity} ${quantity === 1 ? 'bottle' : 'bottles'} · every 8 weeks` : `${quantity} ${quantity === 1 ? 'bottle' : 'bottles'} · ${plan ? 'Subscription' : 'One-time'}`;
      }
    };
    [...bundles,...choices].forEach(input => input.addEventListener('change', update));
    update();
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (adding || cartBusy || form.dataset.available === 'false') return;
      const pack = bundles.find(input => input.checked);
      const plan = choices.find(input => input.checked && input.dataset.planId);
      adding = true; update(); error.hidden = true; busyCart(true);
      try {
        await requestCart('cart/add.js', { id: Number(plan ? pack.dataset.subscriptionVariantId : pack.dataset.variantId), quantity: plan ? 1 : Number(pack.dataset.quantity), ...(plan ? { selling_plan: Number(plan.dataset.planId), properties: { 'Bottles per pack': String(pack.dataset.quantity), 'Pack offer': pack.dataset.promoCopy || '1 bottle' } } : {}) });
        await loadCart();
        await applyWelcome();
        showError(''); showDialog(cartDrawer);
      } catch (failure) { error.textContent = failure.message; error.hidden = false; }
      finally { adding = false; busyCart(false); update(); }
    });
  });

  const initializeGalleries = scope => scope.querySelectorAll('[data-gallery]').forEach(gallery => {
    if (gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';
    const image = gallery.querySelector('.aube-gallery-image');
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-image]')];
    let current = 0;
    let displayed = 0;
    let selection = 0;
    const prepared = new Map();
    const gallerySizes = image.getAttribute('sizes') || '(min-width: 900px) 45vw, 100vw';
    const prepare = (index, priority = 'low') => {
      index = (index + thumbnails.length) % thumbnails.length;
      if (prepared.has(index)) {
        const entry = prepared.get(index);
        if (priority === 'high') entry.image.fetchPriority = 'high';
        return entry.promise;
      }
      const button = thumbnails[index];
      const next = new Image();
      next.decoding = 'async';
      next.fetchPriority = priority;
      const promise = new Promise((resolve, reject) => {
        next.onload = () => (next.decode ? next.decode().catch(() => {}) : Promise.resolve()).then(() => resolve(next));
        next.onerror = () => { prepared.delete(index); reject(new Error('Image unavailable')); };
      });
      prepared.set(index, { image: next, promise });
      if (button.dataset.gallerySrcset) {
        next.sizes = gallerySizes;
        next.srcset = button.dataset.gallerySrcset;
      }
      next.src = button.dataset.galleryImage;
      return promise;
    };
    const warmNeighbours = () => {
      if (navigator.connection?.saveData) return;
      [current + 1, current - 1].forEach(index => prepare(index).catch(() => {}));
    };
    const select = async index => {
      current = (index + thumbnails.length) % thumbnails.length;
      const target = current;
      const request = ++selection;
      const button = thumbnails[target];
      gallery.setAttribute('aria-busy', 'true');
      try {
        const ready = await prepare(target, 'high');
        if (request !== selection) return;
        // Keep the current photo visible until its replacement is decoded.
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = ready.currentSrc || ready.src;
        displayed = target;
        image.alt = button.dataset.galleryAlt || `aübe Lymphatic Drainage Drops · ${button.dataset.galleryCaption}`;
        gallery.querySelector('[data-gallery-current-caption]').textContent = button.dataset.galleryCaption;
        gallery.querySelector('[data-gallery-position]').textContent = `${target + 1} / ${thumbnails.length}`;
        thumbnails.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        const strip = gallery.querySelector('.aube-gallery-thumbs');
        strip.scrollTo({ left: button.offsetLeft - strip.offsetLeft - (strip.clientWidth - button.clientWidth) / 2, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        warmNeighbours();
      } catch {
        if (request === selection) current = displayed;
      } finally {
        if (request === selection) gallery.setAttribute('aria-busy', 'false');
      }
    };
    const startWarmup = () => {
      if ('requestIdleCallback' in window) requestIdleCallback(warmNeighbours, { timeout: 1200 });
      else setTimeout(warmNeighbours, 200);
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          observer.disconnect();
          startWarmup();
        }
      }, { rootMargin: '350px' });
      observer.observe(gallery);
    } else startWarmup();
    thumbnails.forEach((button, index) => {
      ['pointerenter', 'focus', 'touchstart'].forEach(event => button.addEventListener(event, () => prepare(index).catch(() => {}), { passive: true }));
      button.addEventListener('click', () => select(index));
      button.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        select(event.key === 'Home' ? 0 : event.key === 'End' ? thumbnails.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
        thumbnails[current].focus({ preventScroll: true });
      });
    });
    gallery.querySelector('[data-gallery-prev]').addEventListener('click', () => select(current - 1));
    gallery.querySelector('[data-gallery-next]').addEventListener('click', () => select(current + 1));
  });
  initializeGalleries(document);
  document.addEventListener('shopify:section:load', event => initializeGalleries(event.target));
  const nav = document.getElementById('MobileNavDrawer');
  const menu = document.getElementById('mobile-menu-btn');
  menu?.addEventListener('click', () => { showDialog(nav); menu.setAttribute('aria-expanded','true'); });
  document.getElementById('mobile-nav-close')?.addEventListener('click', () => closeDialog(nav));
  nav?.addEventListener('close', () => menu?.setAttribute('aria-expanded','false'));
  nav?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => closeDialog(nav)));
  if (stickyBar && offerForm) {
    const updateSticky = () => {
      const rect = offerForm.querySelector('[data-bundle-submit]').getBoundingClientRect();
      const visible = window.scrollY > 160 && (rect.top > innerHeight || rect.bottom < 0);
      const offerRect = document.getElementById('wellness-offers').getBoundingClientRect();
      document.body.classList.toggle('aube-purchase-visible', offerRect.top < innerHeight * .6 && offerRect.bottom > innerHeight * .3);
      stickyBar.classList.toggle('visible',visible);
      stickyBar.inert = !visible;
      const cta = stickyBar.querySelector('[data-sticky-cta]');
      const choicesRect = offerForm.querySelector('.wellness-pack-grid').getBoundingClientRect();
      const canPurchase = rect.bottom < 0 || (choicesRect.top < innerHeight && choicesRect.bottom > 0);
      cta.dataset.canPurchase = String(canPurchase);
      cta.textContent = canPurchase ? cta.dataset.purchaseLabel || 'Add to cart' : 'Choose my pack';
    };
    window.addEventListener('scroll',updateSticky,{passive:true});
    window.addEventListener('resize',updateSticky);
    updateSticky();
    stickyBar.querySelector('[data-sticky-cta]').addEventListener('click', event => {
      if (event.currentTarget.dataset.canPurchase === 'true') {
        event.preventDefault();
        offerForm.requestSubmit(offerForm.querySelector('[data-bundle-submit]'));
      } else if (scrollToOffers()) event.preventDefault();
    });
  }
  document.querySelectorAll('.wellness-hero__video').forEach(video => {
    video.muted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    const resume = () => {
      if (video.isConnected && !document.hidden && video.paused) video.play().catch(() => {});
    };
    video.addEventListener('canplay', resume);
    video.addEventListener('pause', resume);
    document.addEventListener('visibilitychange', resume);
    document.addEventListener('pointerdown', resume, { once: true, passive: true });
    resume();
  });
  document.querySelectorAll('[data-scratch-section]').forEach(dialog => {
    const canvas = dialog.querySelector('[data-scratch-canvas]');
    const card = dialog.querySelector('[data-scratch-card]');
    const revealButton = dialog.querySelector('[data-scratch-reveal]');
    const cta = dialog.querySelector('[data-scratch-cta]');
    const instruction = dialog.querySelector('[data-scratch-instruction]');
    const context = canvas.getContext('2d',{willReadFrequently:true});
    const key = `${dialog.dataset.storageKey}-v2`;
    let revealed = !!welcomeCode;
    let scratching = false;
    let lastPoint = null;
    let lastCheck = 0;
    let seen = false;
    try { seen = !!sessionStorage.getItem(key); } catch (_) {}
    const updateReveal = () => {
      card.classList.toggle('is-revealed',revealed);
      canvas.hidden = revealed;
      revealButton.hidden = revealed;
      cta.hidden = !revealed;
      if (revealed) instruction.textContent = welcomeCode ? `${welcomeCode} is claimed. Eligible savings appear in your cart.` : 'Your 10% welcome offer is ready. Click below to claim it.';
      if (revealed) cta.textContent = welcomeCode ? 'Shop with my welcome offer →' : 'Claim my 10% welcome offer →';
    };
    const setup = () => {
      if (!context || !dialog.open || revealed) return;
      const rect = card.getBoundingClientRect();
      const dpr = Math.min(2,window.devicePixelRatio || 1);
      canvas.width = rect.width * dpr; canvas.height = rect.height * dpr;
      context.setTransform(dpr,0,0,dpr,0,0);
      context.globalCompositeOperation = 'source-over';
      const gradient = context.createLinearGradient(0,0,rect.width,rect.height);
      gradient.addColorStop(0,'#c7dccb'); gradient.addColorStop(.5,'#f2ead9'); gradient.addColorStop(1,'#adc8b5');
      context.fillStyle = gradient; context.fillRect(0,0,rect.width,rect.height);
      context.textAlign = 'center'; context.fillStyle = '#164f37';
      context.font = '600 17px Inter, sans-serif'; context.fillText('SCRATCH TO REVEAL',rect.width/2,rect.height/2);
      context.font = '12px Inter, sans-serif'; context.fillText('A LITTLE GIFT FROM AÜBE',rect.width/2,rect.height/2+28);
    };
    const markSeen = () => { seen = true; try { sessionStorage.setItem(key,'1'); } catch (_) {} };
    const open = () => { dialog.classList.add('is-open'); showDialog(dialog); updateReveal(); requestAnimationFrame(setup); };
    const dismiss = () => { markSeen(); closeDialog(dialog); };
    dialog.addEventListener('close', () => { dialog.classList.remove('is-open'); markSeen(); });
    dialog.querySelectorAll('[data-scratch-dismiss]').forEach(button => button.addEventListener('click',dismiss));
    const trigger = document.createElement('button'); trigger.type='button'; trigger.className='aube-gift-trigger'; trigger.textContent='✦ Welcome gift'; trigger.setAttribute('aria-label','Open welcome gift');
    dialog.after(trigger); trigger.addEventListener('click',open);
    const reveal = () => {
      if (revealed) return;
      revealed = true;
      updateReveal();
    };
    const scratch = event => {
      if (!scratching || revealed || !context) return;
      const rect = canvas.getBoundingClientRect(); const point={x:event.clientX-rect.left,y:event.clientY-rect.top};
      context.globalCompositeOperation='destination-out'; context.lineWidth=48; context.lineCap='round';
      context.beginPath();context.moveTo(lastPoint?.x ?? point.x,lastPoint?.y ?? point.y);context.lineTo(point.x,point.y);context.stroke();
      context.beginPath();context.arc(point.x,point.y,24,0,Math.PI*2);context.fill();lastPoint=point;
      if (performance.now()-lastCheck<120) return; lastCheck=performance.now();
      const pixels=context.getImageData(0,0,canvas.width,canvas.height).data;let clear=0,total=0;
      for(let index=3;index<pixels.length;index+=64){total++;if(pixels[index]<80)clear++;}
      if(clear/total>.38)reveal();
    };
    canvas.addEventListener('pointerdown',event=>{scratching=true;lastPoint=null;canvas.setPointerCapture(event.pointerId);scratch(event);});
    canvas.addEventListener('pointermove',scratch);
    ['pointerup','pointercancel'].forEach(name=>canvas.addEventListener(name,()=>{scratching=false;lastPoint=null;}));
    revealButton.addEventListener('click',reveal);
    cta.addEventListener('click', async event => {
      event.preventDefault();
      if (cta.getAttribute('aria-busy') === 'true') return;
      cta.setAttribute('aria-busy','true');
      cta.textContent = 'Applying your welcome offer…';
      welcomeCode = dialog.dataset.couponCode;
      try { sessionStorage.setItem('aube-wellness-coupon',welcomeCode); sessionStorage.setItem('aube-welcome-claimed-v2','1'); } catch (_) {}
      markSeen();
      await applyWelcome();
      syncWelcome();
      cta.setAttribute('aria-busy','false');
      updateReveal();
      dismiss();
      scrollToOffers();
    });
    window.addEventListener('resize',setup);
    if (!seen && dialog.dataset.designMode!=='true' && !/\/(cart|account)/.test(location.pathname)) {
      const maybeOpen = () => {
        if(seen)return;
        if(document.hidden || document.querySelector('dialog[open], [role="alertdialog"]') || cartBusy){setTimeout(maybeOpen,2000);return;}
        open();
      };
      setTimeout(maybeOpen,Number(dialog.dataset.delay || 10000));
    }
  });
});
